var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_446_1557",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 29,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H31.5645V58.7918H3V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_446_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8395 2.76188C29.8395 4.34957 28.709 5.72678 27.1513 6.03693C25.5894 6.34778 24.0122 5.50654 23.4023 4.03524L22.7618 2.49076C21.4648 2.92288 20.19 3.45049 18.964 4.06451L19.6164 5.63827C20.2186 7.09075 19.7056 8.78089 18.3974 9.65559C17.0634 10.5505 15.2694 10.3735 14.1334 9.2388L12.9687 8.07486C11.9344 8.97256 10.9594 9.94692 10.0624 10.9805L11.2437 12.1626C12.3693 13.2875 12.5429 15.0627 11.657 16.3841C10.7719 17.7042 9.06431 18.2206 7.59511 17.6122L6.04853 16.9717C5.43451 18.1955 4.90621 19.4696 4.47339 20.768L6.01926 21.4078C7.49056 22.017 8.33319 23.5921 8.02165 25.154C7.7108 26.7118 6.3315 27.8429 4.74172 27.8429H3.07179C3.02439 28.5246 3 29.2139 3 29.8969C3 30.5792 3.02439 31.2685 3.07179 31.9509H4.73963C6.32941 31.9509 7.7108 33.0827 8.02165 34.6419C8.33319 36.2024 7.49126 37.7768 6.01996 38.386L4.47339 39.0265C4.90551 40.3249 5.43381 41.5983 6.04853 42.8222L7.5972 42.181C9.06431 41.5732 10.7712 42.0897 11.6549 43.4083C12.5422 44.7312 12.3679 46.5084 11.2409 47.6347L10.0617 48.814C10.9587 49.8476 11.9337 50.822 12.9687 51.7197L14.1501 50.539C15.2771 49.4134 17.0543 49.2398 18.3772 50.1257C19.6965 51.0094 20.213 52.7163 19.6052 54.1834L18.964 55.73C20.19 56.344 21.4634 56.8723 22.7618 57.3037L23.4323 55.6861C24.024 54.2573 25.5539 53.4384 27.0732 53.7422L27.2252 53.7722C28.7397 54.074 29.8395 55.4136 29.8395 56.9574V58.704C30.3636 58.7409 30.8926 58.7632 31.4195 58.7723V42.1064C24.8973 41.8562 19.668 36.4756 19.668 29.8969C19.668 23.3175 24.8973 17.937 31.4195 17.6867V1.02295C30.8926 1.03131 30.3636 1.05431 29.8395 1.09125V2.76188Z",
    fill: "url(#paint0_linear_446_1557)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4605 28.6377C39.4605 28.7785 39.4514 28.9178 39.4326 29.0558C39.4138 29.1938 39.3859 29.3277 39.349 29.4573C39.312 29.5876 39.2674 29.711 39.2137 29.8274C39.1608 29.9445 39.0994 30.0525 39.0318 30.1522C38.9635 30.2518 38.8896 30.3404 38.8102 30.4184C38.73 30.4965 38.6457 30.5627 38.5572 30.6164C38.468 30.67 38.3767 30.7111 38.2826 30.7383C38.1878 30.7655 38.093 30.7794 37.9968 30.7794C37.9007 30.7794 37.8052 30.7655 37.7111 30.7383C37.617 30.7111 37.5257 30.67 37.4365 30.6164C37.348 30.5627 37.2636 30.4965 37.1835 30.4184C37.1033 30.3404 37.0294 30.2518 36.9618 30.1522C36.8935 30.0525 36.8329 29.9445 36.7799 29.8274C36.7263 29.711 36.681 29.5876 36.6447 29.4573C36.6078 29.3277 36.5799 29.1938 36.5611 29.0558C36.5423 28.9178 36.5332 28.7785 36.5332 28.6377C36.5332 28.4976 36.5423 28.3582 36.5611 28.2202C36.5799 28.0822 36.6078 27.9484 36.6447 27.818C36.681 27.6884 36.7263 27.565 36.7799 27.4479C36.8329 27.3315 36.8935 27.2228 36.9618 27.1239C37.0294 27.0242 37.1033 26.9357 37.1835 26.8576C37.2636 26.7789 37.348 26.7133 37.4365 26.6597C37.5257 26.6053 37.617 26.5649 37.7111 26.5377C37.8052 26.5098 37.9007 26.4966 37.9968 26.4966C38.093 26.4966 38.1878 26.5098 38.2826 26.5377C38.3767 26.5649 38.468 26.6053 38.5572 26.6597C38.6457 26.7133 38.73 26.7789 38.8102 26.8576C38.8896 26.9357 38.9635 27.0242 39.0318 27.1239C39.0994 27.2228 39.1608 27.3315 39.2137 27.4479C39.2674 27.565 39.312 27.6884 39.349 27.818C39.3859 27.9484 39.4138 28.0822 39.4326 28.2202C39.4514 28.3582 39.4605 28.4976 39.4605 28.6377Z",
    fill: "url(#paint1_linear_446_1557)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3725 47.3295C40.3725 46.8577 39.9467 46.4736 39.4219 46.4736H34.5117V49.1151H40.3725V47.3295Z",
    fill: "url(#paint2_linear_446_1557)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5117 50.0625H41.9149V52.2496H34.5117V50.0625Z",
    fill: "url(#paint3_linear_446_1557)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4475 41.3965C38.4475 39.3822 39.5459 37.4767 41.3134 36.4229C42.8614 35.5008 44.8547 33.9668 45.5628 31.8933C46.3093 29.7097 46.1218 27.4439 45.0743 25.9796C44.3292 24.9383 43.2175 24.3877 41.8605 24.3877C40.0756 24.3877 39.1619 25.1655 38.7416 25.7015C39.7076 26.105 40.4074 27.2683 40.4074 28.6371C40.4074 30.3405 39.3257 31.7261 37.9966 31.7261C36.6667 31.7261 35.585 30.3405 35.585 28.6371C35.585 27.3498 36.204 26.2451 37.08 25.7816C36.3559 25.1084 35.5342 24.5571 34.5117 24.4232V45.526H38.4482V41.3965H38.4475Z",
    fill: "url(#paint4_linear_446_1557)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_446_1557",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 1,
    width: 24,
    height: 49
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4199 1H57.9997V49.157H34.4199V1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_446_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5137 1.02441V23.4716C35.9271 23.6173 37.0123 24.3902 37.8995 25.2496C38.4118 24.5345 39.5688 23.4417 41.8618 23.4417C43.5136 23.4417 44.9292 24.1477 45.8464 25.4301C47.0688 27.1384 47.3044 29.7325 46.4611 32.2005C45.6603 34.5457 43.485 36.2345 41.8005 37.2374C40.318 38.1212 39.3973 39.7152 39.3973 41.3976V45.5272H39.4238C40.4707 45.5272 41.3216 46.3356 41.3216 47.3302V49.1159H41.9594C42.1204 48.1582 42.7574 47.3253 43.6774 46.9211C52.3846 43.0947 58.0112 34.4823 58.0112 24.9778C58.0105 11.9257 47.5135 1.27741 34.5137 1.02441Z",
    fill: "url(#paint5_linear_446_1557)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5117 53.1958H41.9149V55.3836H34.5117V53.1958Z",
    fill: "url(#paint6_linear_446_1557)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5117 58.7746H38.9932C40.4422 58.7746 41.6452 57.7145 41.8724 56.3311H34.5117V58.7746Z",
    fill: "url(#paint7_linear_446_1557)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_1557",
    x1: 17.2098,
    y1: 1.02295,
    x2: 17.2098,
    y2: 58.7723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_446_1557",
    x1: 37.9968,
    y1: 26.4966,
    x2: 37.9968,
    y2: 30.7794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_446_1557",
    x1: 37.4421,
    y1: 46.4736,
    x2: 37.4421,
    y2: 49.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_446_1557",
    x1: 38.2133,
    y1: 50.0625,
    x2: 38.2133,
    y2: 52.2496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_446_1557",
    x1: 40.2634,
    y1: 24.3877,
    x2: 40.2634,
    y2: 45.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_446_1557",
    x1: 46.2624,
    y1: 1.02441,
    x2: 46.2624,
    y2: 49.1159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_446_1557",
    x1: 38.2133,
    y1: 53.1958,
    x2: 38.2133,
    y2: 55.3836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_446_1557",
    x1: 38.1921,
    y1: 56.3311,
    x2: 38.1921,
    y2: 58.7746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSolutions);
export default __webpack_public_path__ + "static/media/MobileSolutions.683e302e5b2d97c6a42c602d24b52c49.svg";
export { ForwardRef as ReactComponent };